// import vector2 from "../assets/vector2.svg"
// import scholarship from "../assets/scholarship.svg"
// import s1 from "../assets/s1.svg"
// import s2 from "../assets/s2.svg"
// import s3 from "../assets/s3.svg"
import { FaArrowRightLong } from 'react-icons/fa6'
import Heading from '../components/heading'
import { useRef, useState } from 'react'
import { useInView } from 'framer-motion'
import CampusLifeCard from '../components/campusLifeCard'
import { Link } from 'react-router-dom'
// import { apis } from "../api/apiUrl"
// import axios from "axios"
// import { showImage } from "../api/functions"
import { RowCardWithImageSkelton } from '../components/skeltons'
import { useSelector } from 'react-redux'
import { retrunAssets } from '../utils/getAssets'

const Scholarship = () => {
  const vector2 = '/assets/vector2.svg'
  const ref = useRef(null)

  const [loading] = useState(false)

  const state = useSelector(state => state.homepage)
  const data = state.data?.properties?.financialAids?.items.map(d => {
    return {
      img: retrunAssets(d?.content?.properties?.image[0].url),
      size: 80,
      title: d?.content?.properties?.title,
      description: d?.content?.properties?.description,
      link: '/scholarships'
    }
  })
  const scholarship = retrunAssets(
    state?.data?.properties?.haveAnyQuestionImage[0]?.url
  )

  const sch1 = useRef(null)
  const sch2 = useRef(null)
  const isInViewS1 = useInView(sch1, { once: true })
  const isInViewS2 = useInView(sch2, { once: true })

  return (
    <div
      ref={ref}
      className='w-full lg:h-auto flex flex-col-reverse lg:flex-row  relative bg-[#9C0000] lg:bg-[#f3f3f3] overflow-hidden'
    >
      <div
        className={`flex  flex-col lg:flex-row h-96 bg-white items-center justify-between lg:justify-start lg:min-h-screen lg:items-start lg:bg-[#f3f3f3]  relative w-full`}
      >
        <img
          src={vector2}
          
          className='absolute h-full hidden lg:w-[90%] xl:w-[86%] 2xl:w-[80%]  lg:block z-[1] object-cover object-right'
          alt="Background pattern"
          style={{
            clipPath: 'polygon(0 0, 100% 0, 85% 100%, 0% 100%)'
          }}
        />
        <div
          ref={sch1}
          style={{
            transition: 'all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s'
          }}
          className={`relative lg:absolute ${
            isInViewS1
              ? '!-translate-x-0 !translate-y-0 opacity-1'
              : 'lg:!translate-x-[100%] lg:!translate-y-0 opacity-0'
          } bg-[#9C0000] lg:bg-transparent flex justify-center lg:justify-start w-full h-32  lg:w-1/2  lg:top-0 lg:right-0 lg:h-2/3`}
        >
          <div
            className='absolute lg:relative w-64 h-64 lg:w-full lg:h-[500px] 2xl:h-[600px] bg-no-repeat  bg-center bg-cover'
            style={{ backgroundImage: `url('${scholarship}')` }}
          ></div>
        </div>

        <div
          ref={sch1}
          style={{
            transition: 'all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s'
          }}
          className={`relative  lg:${
            isInViewS1
              ? '!-translate-x-0 !translate-y-0 opacity-100'
              : '!translate-x-[100%] !translate-y-0 opacity-0'
          } lg:absolute lg:w-[35%] h-2/6 2xl:w-2/5 lg:bottom-0 lg:right-0 flex items-center lg:justify-end xl:justify-center lg:pr-5`}
        >
          <div className='w-fit  flex flex-col self-center  gap-2'>
            <h1 className='text-3xl 2xl:text-4xl  font-bold text-gray-900'>
              Have any question ?
            </h1>
            <p className='text-gray-600 max-w-[23rem] font-normal whitespace-pre-line text-xs 2xl:text-sm  w-full '>
              Drop us an enquiry regarding your scholarship application.
            </p>
            <Link
              to={'/contact us'}
              className='p-2 px-3 border w-fit rounded-sm  cursor-pointer text-xs 2xl:text-sm text-[#0039cb]/80 border-[#0039cb] flex items-center gap-1'
            >
              Send Us Message <FaArrowRightLong />
            </Link>
          </div>
        </div>
      </div>
      <div className='relative lg:absolute !z-20 lg:top-0 self-stretch lg:h-full w-full p-8 lg:p-0 lg:w-1/2 lg:pl-32 flex justify-center'>
        <div className='flex flex-col py-4 items-center max-w-xl lg:items-start justify-start text-white  h-full gap-3 2xl:gap-5 '>
          <Heading name='Scholarships' />
          <h1 className=' font-bold text-2xl 2xl:text-4xl'>
            Financial Aid Platforms
          </h1>
          <p className='whitespace-pre-line text-justify text-xs 2xl:text-sm'>
            We believe in empowering bright minds to achieve their dreams.
            Through a variety of financial aid options, including scholarships
            and sponsorships, we ensure that you can focus on what truly
            matters, your future!
          </p>
          <div
            ref={sch2}
            className={`w-full flex flex-col  ${
              data?.length > 2 ? 'justify-evenly' : 'justify-start'
            } gap-2 2xl:gap-5 overflow-hidden`}
          >
            {loading
              ? [0, 1, 2].map(index => (
                  <div
                    key={index}
                    style={{
                      transition:
                        'all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) ' +
                        (500 + index * 100) +
                        'ms'
                    }}
                    className={` animate_scholarShip ${
                      isInViewS2
                        ? 'lg:!translate-x-0 lg:!translate-y-0 lg:opacity-100'
                        : 'lg:!-translate-x-[100%] lg:!translate-y-0 lg:opacity-0'
                    }`}
                  >
                    <RowCardWithImageSkelton />
                  </div>
                ))
              : data?.slice(0, 3).map((card, index) => (
                  <div
                    key={index}
                    style={{
                      transition:
                        'all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) ' +
                        (500 + index * 100) +
                        'ms'
                    }}
                    className={` animate_scholarShip ${
                      isInViewS2
                        ? 'lg:!translate-x-0 lg:!translate-y-0 lg:opacity-100'
                        : 'lg:!-translate-x-[100%] lg:!translate-y-0 lg:opacity-0'
                    }`}
                  >
                    {loading ? (
                      <RowCardWithImageSkelton />
                    ) : (
                      <CampusLifeCard key={index} {...card} light={false} />
                    )}

                  </div>
                ))}
          </div>

                 <Link to={'/scholarships'} className='p-2 px-3  self-end border w-fit rounded-sm transition-all delay-200 font-bold text-xs text-white border-white'>Learn More</Link>
        </div>
      </div>
    </div>
  )
}

export default Scholarship
